import {H2hWidgetController} from "../h2h-widget.controller";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";

export class H2hWidgetProps extends BaseModuleProps {
  controller: H2hWidgetController;
  matchupId: String;
  gameId: Number;
  onSeeAllClick: Function;
}
